import React from "react";
// import { Link, Breadcrumbs, Grid } from "@material-ui/core";
import "./Template.css";
// import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

const Template = ({ children, pageName, breadcrumbValues }) => {
  const navigate = useNavigate();

  const handleClick = (routeData, event) => {
    event.preventDefault();

    navigate({
      pathname: routeData && routeData.pathname,
      state: routeData && routeData.state,
    });
  };

  return (
    <div className="bgImageTemplate">
        <Box sx={{margin:'0 auto',  width:'100%', maxWidth:'1300px'}}>
          {/* <Breadcrumbs
            separator={<NavigateNextIcon style={{ fontSize: '10px' }} />}
            aria-label="breadcrumb"
            className="breadcrumb-lable"
          >
            {breadcrumbValues &&
              breadcrumbValues.length > 0 &&
              breadcrumbValues.map((breadcrumb, index) => (
                <Link
                  key={index}
                  color="inherit"
                  style={{ cursor: "pointer", fontSize: "10px" }}
                  onClick={(e) => handleClick(breadcrumb && breadcrumb.to, e)}
                >
                  {breadcrumb && breadcrumb.name}
                </Link>
              ))}
          </Breadcrumbs> */}
          <div>{children}</div>
      </Box>
    </div>
  );
};

// Template.propTypes = {
//   pageName: PropTypes.string,
//   breadcrumbValues: PropTypes.array,
// };

// Template.defaultProps = {
//   pageName: "",
//   breadcrumbValues: [],
// };

export default Template;
